(function () {
  const Core = window.RB.Core;
  const { buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Leona, Determined": {
      triggers: [{
        on: "attack", self: true,
        label: "stun an enemy unit here",
        targets: [{ bind: "t", spec: { type: "unit", enemy: true, here: true }, prompt: "Stun an enemy unit here" }],
        program: [{ op: "stun", to: "$t" }],
      }],
    },

    "Trifarian Gloryseeker": {
      play: [
        { op: "if", cond: { k: "legion", n: 2 }, then: [{ op: "buff", to: "source" }] },
      ],
    },

    "Back to Back": {
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, min: 2, max: 2, prompt: "Give two friendly units +2 Might" }],
      play: [buff("$t", 2)],
    },

    "Noxian Drummer": {
      triggers: [{
        on: "move", self: true,
        condSpec: { k: "evToBf" },
        label: "Recruit token here",
        program: [{ op: "token", name: "Recruit", n: 1, loc: "here" }],
      }],
    },

    "Vanguard Captain": {
      play: [{
        op: "if", cond: { k: "legion" }, then: [
          { op: "token", name: "Recruit", n: 2, loc: "here" },
        ],
      }],
    },

    "Peak Guardian": {
      play: [
        { op: "buff", to: "source" },
        { op: "buff", spec: { type: "unit", friendly: true, here: true, other: true } },
      ],
    },

    "Solari Chief": {
      play: [
        { op: "choose", bind: "t", spec: { type: "unit", enemy: true }, prompt: "Stun (or kill, if already stunned) which enemy unit?" },
        {
          op: "if", cond: { k: "targetStunned", bind: "t" },
          then: [{ op: "kill", to: "$t" }],
          else: [{ op: "stun", to: "$t" }],
        },
      ],
    },

    "Darius, Executioner": {
      play: [{ op: "if", cond: { k: "legion" }, then: [{ op: "ready", to: "source" }] }],
      auraMightSpecs: [{ n: 1, scope: "here", excludeSelf: true }],
    },

    "Vanguard Helm": {
      triggers: [{
        on: "dies", label: "pass the torch",
        condSpec: { k: "and", conds: [{ k: "evSnapshotUnit" }, { k: "evSnapshotBuffed" }, { k: "evSnapshotFriendly" }] },
        program: [
          { op: "choose", bind: "t", spec: { type: "unit", friendly: true }, prompt: "Buff which other friendly unit?" },
          { op: "buff", to: "$t" },
        ],
      }],
    },

    "Viktor, Leader": {
      triggers: [{
        on: "dies", label: "reinforcements",
        condSpec: { k: "and", conds: [{ k: "evSnapshotUnit" }, { k: "evSnapshotFriendly" }, { k: "evSnapshotOther" }, { k: "evSnapshotNotTag", tag: "Recruit" }] },
        program: [{ op: "token", name: "Recruit", n: 1 }],
      }],
    },

    "Fiora, Victorious": {
      suppressKw: ["deflect", "ganking", "shield"],
      selfKw: function (state, iid) {
        const o = state.objs[iid];
        const c = Core.card(state, iid);
        let m = (c.might || 0) + o.buffs * Core.buffValue(state, o);
        for (const g of o.grants) if (g.k === "might") m += g.value;
        return m >= 5 ? [["deflect", 1], ["ganking", null], ["shield", 1]] : [];
      },
    },

    "Sett, Kingpin": {
      selfMight: function (state, iid) {
        const o = state.objs[iid];
        if (!o.loc || o.loc.t !== "bf") return 0;
        return Core.unitsAt(state, o.loc, function (u) {
          return u.controller === o.controller && u.buffs > 0;
        }).length;
      },
    },

    "Karthus, Eternal": { deathknellDouble: true },

    "Hidden Blade": {
      targets: [{ bind: "t", spec: { type: "unit", atBf: true }, prompt: "Kill which unit at a battlefield?" }],
      play: [
        { op: "draw", n: 2, whoOf: "t" },
        { op: "kill", to: "$t" },
      ],
    },

    "Facebreaker": {
      targets: [
        { bind: "a", spec: { type: "unit", friendly: true, atBf: true }, prompt: "Stun which friendly unit?" },
        { bind: "b", spec: { type: "unit", enemy: true, sameLocAs: "a" }, prompt: "Stun which enemy unit at the same battlefield?" },
      ],
      play: [
        { op: "stun", to: "$a" },
        { op: "stun", to: "$b" },
      ],
    },

    "Imperial Decree": {
      play: [{ op: "delayed", on: "takeDamage", repeat: true, expiresThisTurn: true, program: [{ op: "kill", to: "$ev" }] }],
    },

    "Salvage": {
      play: [
        {
          op: "may", prompt: "Kill a gear?", then: [
            { op: "choose", bind: "g", spec: { type: "gear" }, prompt: "Kill which gear?" },
            { op: "kill", to: "$g" },
          ],
        },
        { op: "draw", n: 1 },
      ],
    },

    "Cull the Weak": {
      play: [
        { op: "choose", bind: "a", spec: { type: "unit", friendly: true }, prompt: "Kill which of your units?" },
        { op: "kill", to: "$a" },
        { op: "choose", bind: "b", spec: { type: "unit", enemy: true }, byOpponent: true, prompt: "Kill which of your units?" },
        { op: "kill", to: "$b" },
      ],
    },

    "King's Edict": {
      play: [
        { op: "choose", bind: "b", spec: { type: "unit", enemy: true }, byOpponent: true, prompt: "Choose one of your units to be killed" },
        { op: "kill", to: "$b" },
      ],
    },

    "Grand Strategem": {
      play: [{ op: "grant", spec: { type: "unit", friendly: true }, might: 5 }],
    },

    "Forge of the Future": {
      play: [{ op: "token", name: "Recruit", n: 1 }],
      abilities: [{
        label: "Kill this: recycle up to 4 cards from trashes", killSelf: true,
        program: [
          { op: "choose", bind: "t", spec: { zone: "trash", anyPlayer: true }, min: 0, max: 4, prompt: "Recycle up to 4 cards from trashes" },
          { op: "recycleTargets", to: "$t" },
        ],
      }],
    },

    "Spectral Matron": {
      play: [{
        op: "may", prompt: "Play a small unit from your trash for free?", then: [
          { op: "choose", bind: "_u", spec: { type: "unit", zone: "trash", maxEnergy: 3, maxPips: 1 }, prompt: "Play which unit?" },
          { op: "playFrom", to: "$_u", waive: "all" },
        ],
      }],
    },

    "Symbol of the Solari": {
      tieRecallAll: true,
    },

    "Albus Ferros": {
      play: [
        { op: "spendBuffs", varKey: "spent", prompt: "Spend a buff to channel a rune (choose none to stop)" },
        { op: "channel", n: { varOf: "spent" }, exhausted: true },
      ],
    },

    "Karma, Channeler": {
      play: [{ op: "predict", n: 1 }],
      triggers: [{
        on: "recycled", you: true, label: "buff a friendly unit",
        targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Buff a friendly unit" }],
        program: [{ op: "buff", to: "$t" }],
      }],
    },

    "Baited Hook": {
      abilities: [{
        cost: { energy: 1, pips: 1, anyPower: 0, domains: ["order"] },
        exhausts: true, label: "Baited Hook",
        targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Kill which friendly unit?" }],
        program: [
          { op: "setVarMight", varKey: "killedMight", from: "$t" },
          { op: "kill", to: "$t" },
          {
            op: "lookTopTake", n: 5, optional: true,
            filter: { type: "unit", maxMightVar: "killedMight", maxMightPlus: 1 },
            prompt: "Banish a unit with Might up to 1 more and play it free", waive: "all",
          },
        ],
      }],
    },

    "Divine Judgment": {
      play: [{
        op: "keepAndRecycle", prompt: "Keep",
        groups: [
          { type: "unit", keep: 2, label: "units" },
          { type: "gear", keep: 2, label: "gear" },
          { type: "rune", keep: 2, label: "runes" },
          { zone: "hand", keep: 2, label: "cards in hand" },
        ],
      }],
    },

    "Call to Glory": {
      play: [buff("$t1", 3)],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give +3 Might to..." }],
      addCosts: [
        {
          optional: true,
          cond: null,
          label: "Call to Glory",
          costSpendBuff: 1,
          discount: { all: true },
        },
      ],
    },

    "Cruel Patron": {
      addCosts: [
        {
          optional: false,
          cond: null,
          label: "Cruel Patron",
          costKill: { type: "unit" },
        },
      ],
    },

    "Commander Ledros": {
      addCosts: [
        {
          optional: true,
          cond: null,
          label: "Commander Ledros",
          costKill: { type: "unit", any: true },
          discountPerPaid: { energy: 0, pips: 1, anyPower: 0, domains: ["order"] },
        },
      ],
    },

    "Seal of Unity": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          exhausts: true,
          reaction: true,
          isAdd: true,
          program: [
            {
              op: "addResources",
              res: { energy: 0, pips: 1, anyPower: 0, domains: ["order"] },
            },
          ],
          label: "Add",
        },
      ],
    },

    "Daring Poro": {},

    "Faithful Manufactor": {
      play: [{ op: "token", name: "Recruit", n: 1, loc: "here", exhausted: false }],
    },

    "Harnessed Dragon": {
      play: [{ op: "kill", to: "$t1" }],
      targets: [{ bind: "t1", spec: { type: "unit", enemy: true }, prompt: "Kill..." }],
    },

    "Machine Evangel": {
      deathknell: [{ op: "token", name: "Recruit", n: 3, loc: "base", exhausted: false }],
    },

    "Petty Officer": {},

    "Shen, Kinkou": {},

    "Soaring Scout": { deathknell: [{ op: "channel", n: 1, exhausted: true }] },

    "Vanguard Sergeant": {},

    "Vengeance": {
      play: [{ op: "kill", to: "$t1" }],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Kill..." }],
    },
  });
})();
